// import { LoginComp } from '@integec/common-react-screens/lib/auth'
import NormalLogin from './NormalLogin'
import React, { useState, useContext } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import * as actions from 'core/actions'
import {
  getLoginError,
  getTwoFactorRegistration,
  getTwoFactorRequired,
  getTwoFactorOptions,
} from 'core/selectors'
import { getApiTargetInfo } from 'core'
import PasswordUpdateForm from './PasswordUpdateForm'
import { doPasswordReset } from 'api/pgads'
import { ErrorContext } from 'context'

import LoginCenterTop from 'image/power gads.jpg'
// import { Divider } from 'antd'
import { getClientInfo } from '../selectors'
// import { SRP_CLIENT } from '../../client'
const Container = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`

const StyledLogin = styled(NormalLogin)`
  min-width: 300px;
  max-width: 450px;
  width: 50vw;
`

const isPasswordUpdate = error => error != null && error.appExceptionId === 334

const LoginScreen = ({
  renderExtra,
  // children,
  doLogin,
  loginError,
  setLoginError,
  apiTargetInfo,
  // CLIENT,
  // doLoginWithoutDataTaskSupport,
  ...rest
}) => {
  const { setError } = useContext(ErrorContext)
  const [errUser, setErrUser] = useState(null)
  const [errPassword, setErrPassword] = useState(null)

  const onPasswordUpdate = data => {
    const cred = {
      ...data,
      username: data.username,
      password: data.newPassword,
      userName: data.username,
    }
    doPasswordReset(apiTargetInfo)(cred).fork(
      err => {
        console.log(err)
        setLoginError(err)
      },
      _ => {
        // doLoginWithoutDataTaskSupport
        // ? doLoginWithoutDataTaskSupport(cred) :
        // console.log('call login all')
        doLogin(cred)
        setError()
      }
    )
  }

  // const clientStyle = {
  //   backgroundImage: CLIENT === SRP_CLIENT && `url(${LoginLeft})`,
  //   paddingTop: CLIENT === SRP_CLIENT && '200px',
  // }

  return (
    <Container>
      {renderExtra && renderExtra()}
      <div
        style={{
          backgroundColor: '#fff',
          // padding: '6rem 1rem',
          height: '85vh',
          width: '80vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <img
            style={{ marginBottom: '1rem', marginTop: '1rem' }}
            src={LoginCenterTop}
          />
          {isPasswordUpdate(loginError) ? (
            <PasswordUpdateForm
              onUpdate={onPasswordUpdate}
              loading={false}
              errorMessage={loginError && loginError.errorMsg}
              initialUser={errUser}
              initialPassword={errPassword}
            />
          ) : (
            <StyledLogin
              apiTargetInfo={apiTargetInfo}
              onLogin={data => {
                setErrUser(data.username)
                setErrPassword(data.password)
                // doLoginWithoutDataTaskSupport
                // ? doLoginWithoutDataTaskSupport(data)              :
                // console.log('login with', data)
                doLogin(data)
                setError()
              }}
              style={{ maxWidth: '450px' }}
              errorMessage={loginError && loginError.errorMsg}
              {...rest}
            />
          )}
        </div>
      </div>
    </Container>
  )
}

const mapStateToProps = state => ({
  loginError: getLoginError(state),
  apiTargetInfo: getApiTargetInfo(state),
  CLIENT: getClientInfo(state),
  twoFactorRegistration: getTwoFactorRegistration(state),
  twoFactorRequired: getTwoFactorRequired(state),
  twoFactorOptions: getTwoFactorOptions(state),
})

const mapDispatchToProps = dispatch => ({
  doLogin: arg => dispatch(actions.doLogin(arg)),
  clearLoginError: _ => dispatch(actions.setLoginError(null)),
  setLoginError: error => dispatch(actions.setLoginError(error)),
})
export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen)
